import React from 'react';
import { connect } from 'react-redux';

import Layout from './components/layout';
import Header from '../components/global/header';
import Footer from '../components/global/footer/index';

const HomePageComponent = ({ user, search, patient }) => {
  return (
    <div>
      <Header />
      <Layout user={user} searchFocused={search.focused} patient={patient} />
      <Footer />
    </div>
  );
};

const mapStateToProps = ({ user, search, patient }) => ({ user, search, patient });

const HomePageContainer = connect(mapStateToProps, null)(HomePageComponent);

export default HomePageContainer;
